import { render, staticRenderFns } from "./DepartmentEditor.vue?vue&type=template&id=fdb72c86&scoped=true&"
import script from "./DepartmentEditor.vue?vue&type=script&lang=js&"
export * from "./DepartmentEditor.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentEditor.vue?vue&type=style&index=0&id=fdb72c86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb72c86",
  null
  
)

export default component.exports